<!--src/views/LayoutCommon.vue-->
<script setup>
// 导入拆分后的头、尾组件
import CommonHeader from '../components/nav/CommonHeader.vue'
// import CommonFooter from '../components/footer/CommonFooter.vue'
</script>

<template>
  <div class="layout-container">
    <!-- 头部导航（复用拆分后的组件） -->
    <CommonHeader />
    <!-- 路由内容出口（所有页面都会渲染在这里） -->
    <div class="layout-content">
      <router-view />
    </div>
    <!-- 底部Footer（复用拆分后的组件） -->
    <!--    <CommonFooter />-->
  </div>
</template>

<style scoped lang="scss">
.layout-container {
  width: 100% !important;
  min-width: 320px !important; /* 小屏最小宽度（手机最小宽度） */
  max-width: 1920px !important; /* 大屏最大宽度 */
  margin: 0 auto !important; /* 全局居中 */
  padding: 0 3rem !important;
  overflow-x: hidden !important;
}

.layout-content {
  width: 100% !important;
  padding: 0 5px !important; /* 小屏左右留边距，避免贴边 */
}

/* 🌟 全局小屏适配（作用于所有内容：头部、路由页面、底部） */
@media (max-width: 991.98px) {
  .layout-container {
    width: 95% !important; /* 小屏占 95% 宽度，居中 */
    padding: 0 !important;
  }

  .layout-content {
    //padding: 0 5px !important; /* 小屏边距缩小 */
  }
}

/* 超小屏（手机）适配 */
@media (max-width: 575.98px) {
  .layout-container {
    width: 100% !important; /* 手机端全屏，无多余边距 */
  }

  .layout-content {
    padding: 0 5px !important;
  }
}
</style>
